import {AccountState, AccountType, QrCodeSearchCriteria} from 'web-angular-client';

export class QrCodeSearchCriteriaImpl implements QrCodeSearchCriteria
{

    dateTimeCreatedLower?: string;
    dateTimeCreatedUpper?: string;
    state?: AccountState[];
    description?: string;
    accountType: AccountType;

    constructor(accountType: AccountType)
    {
        this.dateTimeCreatedLower = null;
        this.dateTimeCreatedUpper = null;
        this.state = [];
        this.description = null;
        this.accountType = accountType;
    }
}